require("babel-polyfill");
require('@/assets/css/reset.css');
require('@/assets/css/page.css');
require('@/assets/css/duDatepicker.css');
require("@/service/public");
require("@/service/duDatepicker");
var App = require('C/app');

var $el = document.getElementById('app');

var Main = san.defineComponent({
    template: '<div><app /></div>',
    components: {
        'app': App
    },
    created: function() {

    }
});

var body = new Main();
body.attach($el);

/* webpack 热替换 */
if (module.hot) {
    module.hot.accept();
}



//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 134
// module chunks = 1